function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { Subscriber } from "rxjs";
import store from "../store";
import { logError } from "../actions";
import SocialAPI from "./SocialAPIUtils";
export var headerDefault = {
    "Content-Type": "application/json"
};
export var getAjaxSettings = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", state = arguments.length > 1 ? arguments[1] : void 0, method = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "GET", body = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, headers = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, onProgress = arguments.length > 5 ? arguments[5] : void 0, onComplete = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {};
    return {
        url: url,
        method: method,
        body: body,
        progressSubscriber: onProgress ? Subscriber.create(onProgress, function(error) {
            store.dispatch(logError({
                error: error
            }));
            onComplete(error, true);
        }, onComplete) : undefined,
        responseType: "json",
        headers: Object.assign({}, _instanceof(body, FormData) ? {} : headerDefault, headers, {
            credentials: "same-origin"
        })
    };
};
export var getAjaxSettingsForTweet = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", state = arguments.length > 1 ? arguments[1] : void 0, method = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "GET", body = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, headers = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, onProgress = arguments.length > 5 ? arguments[5] : void 0, onComplete = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {};
    return {
        url: url,
        method: method,
        body: body,
        progressSubscriber: onProgress ? Subscriber.create(onProgress, function(error) {
            store.dispatch(logError({
                error: error
            }));
            onComplete(error, true);
        }, onComplete) : undefined,
        responseType: "json",
        headers: Object.assign({}, _instanceof(body, FormData) ? {} : headerDefault, headers, {
            Authorization: SocialAPI.getSessionToken(),
            "Chache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: -1
        })
    };
};
